import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { monthNames } from './monthNames';

export const monthNavigatorTemplate = (e, rdd, selectedYear, setDisablePrevMonth, monthDDRef, dropdownstyle, onMonthChange) => {
    if (e.value !== '' && rdd) {
        const now = new Date();
        const selectedMonthName = monthNames.find((item) => item.id === e.value).name.toLowerCase();
        const currentMonthName = monthNames[now.getMonth()].name.toLowerCase();
        setDisablePrevMonth((selectedMonthName.includes('january') && selectedYear === now.getFullYear()) ||
            (selectedMonthName.includes(currentMonthName) && selectedYear === now.getFullYear()));
    }
    let count = monthNames.find((m) => m.name === e.names[0]).id - 1;
    const options = e.options.map((opt) => ({ ...opt, value: ++count, index: count }));
    return (
        <span>
            <Dropdown
                onChange={(event) => {
                    if (onMonthChange) {
                        onMonthChange(event.value);
                    } else {
                        e.onChange(event.originalEvent, event.value);
                    }
                }}
                value={e.value}
                options={options}
                style={dropdownstyle}
                appendTo={'self'}
                id="monthDD"
                ref={monthDDRef}
            />
        </span>
    );
};
